import React, { useEffect, useRef, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { Loading } from "go-core/components/Loading";
import { ReactComponent as ConversationSVG } from "../../../../../../images/svg/organization/conversation.svg";
import { IntercomConversationApi } from "../../../../../../services/Api/Admin/adminTypes";

interface Props {
	conversation: IntercomConversationApi;
	loading: boolean;
}

const OrganizationSupportCard = ({ conversation, loading }: Props) => {
	const { t } = useTranslation("admin");
	const [showMore, setShowMore] = useState<boolean>(false);
	const [displayShowMoreButton, setDisplayShowMoreButton] = useState<boolean>(false);
	const ref = useRef<HTMLDivElement | null>(null);
	const messageContent = conversation?.source?.message;

	useEffect(() => {
		const offsetHeight = ref.current?.offsetHeight;
		const scrollHeight = ref.current?.scrollHeight;
		if (offsetHeight && scrollHeight && offsetHeight < scrollHeight) {
			setDisplayShowMoreButton(true);
		}
	}, [ref]);

	return (
		<Card className="support-card">
			<Card.Body>
				<h5>{t("common.word.support")}</h5>
				{loading ? (
					<Loading />
				) : (
					<div>
						<div className="card-body-item">
							<ConversationSVG />
							<div className="d-flex flex-column">
								<span className="label">{FormatDate(conversation?.created_at)}</span>
								<span
									dangerouslySetInnerHTML={{ __html: messageContent }}
									className={!showMore ? "conversation-message--hidden" : ""}
									ref={ref}
								/>
							</div>
						</div>
						{displayShowMoreButton && (
							<Button variant="add" className="w-100 mt-2" onClick={() => setShowMore(!showMore)}>
								{showMore
									? t("lib:common.action.show_less")
									: t("common.action.show_more", { ns: "lib" })}
							</Button>
						)}
					</div>
				)}
			</Card.Body>
		</Card>
	);
};

export default OrganizationSupportCard;
